import { render, staticRenderFns } from "./PickleBanner.vue?vue&type=template&id=a6e81ac6&"
import script from "./PickleBanner.vue?vue&type=script&lang=js&"
export * from "./PickleBanner.vue?vue&type=script&lang=js&"
import style0 from "./PickleBanner.vue?vue&type=style&index=0&lang=sass&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports